export const LICENSE_KEY_LIST_REQUEST = "LICENSE_KEY_LIST_REQUEST";
export const LICENSE_KEY_LIST_SUCCESS = "LICENSE_KEY_LIST_REQUEST_SUCCESS";
export const LICENSE_KEY_CREATE_REQUEST = "LICENSE_KEY_CREATE_REQUEST";
export const LICENSE_KEY_DETAIL_REQUEST = "LICENSE_KEY_DETAIL_REQUEST";
export const LICENSE_KEY_ARCHIVE_REQUEST = "LICENSE_KEY_ARCHIVE_REQUEST";
export const LICENSE_KEY_DELETE_REQUEST = "LICENSE_KEY_DELETE_REQUEST";
export const LICENSE_KEY_UNARCHIVE_REQUEST = "LICENSE_KEY_UNARCHIVE_REQUEST";
export const LICENSE_KEY_EDIT_REQUEST = "LICENSE_KEY_EDIT_REQUEST";
export const LICENSE_KEY_BATCH_DELETE_REQUEST = "LICENSE_KEY_BATCH_DELETE_REQUEST";
export const LICENSE_KEY_CREATE_FORM_NAME = "createLicenseKey";
export const LICENSE_KEY_EDIT_FORM_NAME = "editLicenseKey";
export const LICENSE_KEY_AUTOCOMPLETE_REQUEST = "LICENSE_KEY_AUTOCOMPLETE_REQUEST";
export const LICENSE_KEY_AUTOCOMPLETE_SUCCESS = "LICENSE_KEY_AUTOCOMPLETE_SUCCESS";

export const LICENSE_KEY_SUBMIT_RULES = {
  licenseKey: {
    required: true,
    min: (value) => {
      if (!value) {
        return false;
      }
      const normalized = String(value).replace(/[^a-zA-Z0-9]/g, "");
      return normalized.length !== 20;
    },
    minMessage: "License key must be 20 alphanumeric characters",
  },
};

export const READ_LICENSE_KEY = 279000;
export const CREATE_LICENSE_KEY = 279001;
export const UPDATE_LICENSE_KEY = 279002;
export const DELETE_LICENSE_KEY = 279003;
export const ARCHIVE_LICENSE_KEY = 279004;
export const UNARCHIVE_LICENSE_KEY = 279005;
export const BATCH_DELETE_LICENSE_KEY = 279006;
export const IMPORT_LICENSE_KEY = 279008;
export const EXPORT_LICENSE_KEY = 279009;
